(function () {
  'use strict';

  var panelOffsetScheduled = false;

  function setRootStyle(name, value) {
    var style = document.documentElement.style;
    if (style.getPropertyValue(name) === value) return;
    if (value) style.setProperty(name, value);
    else style.removeProperty(name);
  }

  function syncMobilePanelOffset() {
    var header = document.getElementById('SiteHeader');

    panelOffsetScheduled = false;

    if (window.innerWidth > 768) {
      var desktopSearchInput = header && header.querySelector('.dw-header-search .search__input');
      var searchWidth = desktopSearchInput ? Math.round(desktopSearchInput.getBoundingClientRect().width) : 0;
      setRootStyle('--dw-mobile-panel-top', '');
      setRootStyle('--dw-desktop-search-width', searchWidth > 0 ? searchWidth + 'px' : '');
      return;
    }

    if (!header) {
      setRootStyle('--dw-desktop-search-width', '');
      setRootStyle('--dw-mobile-panel-top', '');
      return;
    }

    var headerRect = header.getBoundingClientRect();
    var visibleHeaderBottom = Math.min(window.innerHeight, Math.max(0, headerRect.bottom));
    var panelTop = Math.max(headerRect.height, visibleHeaderBottom);

    setRootStyle('--dw-desktop-search-width', '');
    setRootStyle('--dw-mobile-panel-top', Math.round(panelTop) + 'px');
  }

  function scheduleMobilePanelOffset() {
    if (panelOffsetScheduled) return;

    panelOffsetScheduled = true;
    window.requestAnimationFrame(syncMobilePanelOffset);
  }

  function scheduleScrollOffset() {
    if (window.innerWidth <= 768) scheduleMobilePanelOffset();
  }

  function start() {
    syncMobilePanelOffset();

    window.addEventListener('resize', scheduleMobilePanelOffset);
    window.addEventListener('scroll', scheduleScrollOffset, { passive: true });
    window.addEventListener('pageshow', scheduleMobilePanelOffset);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleMobilePanelOffset);
      window.visualViewport.addEventListener('scroll', scheduleScrollOffset);
    }

    document.addEventListener('pointerdown', function (event) {
      if (!event.target.closest('.js-drawer-open-nav, .boost-sd__filter-tree-toggle-button')) return;
      syncMobilePanelOffset();
    }, true);

    if ('ResizeObserver' in window) {
      var header = document.getElementById('SiteHeader');
      if (header) {
        var resizeObserver = new ResizeObserver(scheduleMobilePanelOffset);
        resizeObserver.observe(header);
        var desktopSearchInput = header.querySelector('.dw-header-search .search__input');
        if (desktopSearchInput) resizeObserver.observe(desktopSearchInput);
      }
    }
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
}());
